import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=f1434b80&scoped=true&"
import script from "./BankAccount.vue?vue&type=script&lang=ts&"
export * from "./BankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccount.vue?vue&type=style&index=0&id=f1434b80&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1434b80",
  null
  
)

export default component.exports